import { Reducer } from 'redux'
import { ActionTypes, TCurrentTimeState } from './types'

export const initialState: TCurrentTimeState = {
  loading: false,
  data: null,
}

const reducer: Reducer<TCurrentTimeState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CURRENT_TIME_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_CURRENT_TIME_S:
      return { ...state, loading: false, errors: undefined, data: action.payload }
    case ActionTypes.GET_CURRENT_TIME_E:
      return { ...state, loading: false, errors: action.payload }
    
    default:
      return state
  }
}

export { reducer as CurrentTimeReducer }